module.exports = __webpack_public_path__ + "img/aiIcon.1ff56e76.png";